<template>
  <div style="min-width:1300px;">
    <el-row>
      <el-col :span="8">
        <transition name="el-fade-in-linear">
          <div
            class="bg_1967C3 product-li"
            @click="goUrl('cusKc')"
            @mouseleave="rules.show=false"
            @mouseenter="rules.show=true"
          >
            <div class="product-title">1.定制客运平台</div>
            <div class="product-line"></div>
            <div class="product-text fs14">在班车客运业务的基础上开展定制客运服务</div>
            <img
              class="product-img"
              src="@/image/index/icon_pro1.png"
              alt
            />
            <img
              v-show="rules.show"
              :class="[{'product-li-fade':rules.show}]"
              class="product-big-img"
              src="@/image/index/icon_pro1s.png"
              alt
            />
          </div>
        </transition>
      </el-col>
      <el-col :span="8">
        <transition name="el-fade-in-linear">
          <div
            class="bg_538DD2 product-li-t"
            @click="goUrl('szbc')"
            @mouseleave="rules.show2=false"
            @mouseenter="rules.show2=true"
          >
            <div class="product-title">2.数字城乡班车平台</div>
            <div class="product-line"></div>
            <div class="product-text-t fs14">城际客运，城乡客运的互联网平台化</div>
            <img
              class="product-img-t"
              src="@/image/index/icon_pro2.png"
              alt
            />
            <img
              v-show="rules.show2"
              :class="[{'product-li-fade':rules.show2}]"
              class="product-big-img-t"
              src="@/image/index/icon_pro2s.png"
              alt
            />
          </div>
        </transition>
        <transition name="el-fade-in-linear">
          <div
            class="bg_3076C9 product-li-t"
            @click="goUrl('szgj')"
            @mouseleave="rules.show4=false"
            @mouseenter="rules.show4=true"
          >
            <div class="product-title">4.数字公交平台</div>
            <div class="product-line"></div>
            <div class="product-text-t fs14">公交业务的互联网平台化和开展定制公<br />交业务</div>
            <img
              class="product-img-t"
              src="@/image/index/icon_pro4.png"
              alt
            />
            <img
              v-show="rules.show4"
              :class="[{'product-li-fade':rules.show4}]"
              class="product-big-img-t"
              src="@/image/index/icon_pro4s.png"
              alt
            />
          </div>
        </transition>
      </el-col>
      <el-col :span="8">
        <transition name="el-fade-in-linear">
          <div
            class="bg_3076C9 product-li-t"
            @click="goUrl('taxi')"
            @mouseleave="rules.show3=false"
            @mouseenter="rules.show3=true"
          >
            <div class="product-title">3.智能出租车平台</div>
            <div class="product-line"></div>
            <div class="product-text-t fs14">出租车业务的互联网平台化
            </div>
            <img
              class="product-img-t"
              src="@/image/index/icon_pro3.png"
              alt
            />
            <img
              v-show="rules.show3"
              :class="[{'product-li-fade':rules.show3}]"
              class="product-big-img-t"
              src="@/image/index/icon_pro3s.png"
              alt
            />
          </div>
        </transition>
        <transition name="el-fade-in-linear">
          <div
            class="bg_538DD2 product-li-t"
            @click="goUrl('tourismSystem')"
            @mouseleave="rules.show5=false"
            @mouseenter="rules.show5=true"
          >
            <div class="product-title">5.数字包车平台</div>
            <div class="product-line"></div>
            <div class="product-text-t fs14">包车客运、非定线旅游客运业务的互联<br />网平台化</div>
            <img
              class="product-img-t"
              src="@/image/index/icon_pro5.png"
              alt
            />
            <img
              v-show="rules.show5"
              :class="[{'product-li-fade':rules.show5}]"
              class="product-big-img-t"
              src="@/image/index/icon_pro5s.png"
              alt
            />
          </div>
        </transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      rules: {
        show: false,
        show2: false,
        show3: false,
        show4: false,
        show5: false
      }
    };
  },
  methods: {
    goUrl (name) {
      console.log(name)
      this.$router.push({ name })
    }
  },

};

</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>


// WEBPACK FOOTER //
// src/components/myproduct/index.vue